import styled from 'styled-components';

/**
 * Dark translucent MM:SS duration badge overlaid on the bottom-right corner of
 * a thumbnail. The parent must be `position: relative`. The default size suits
 * card thumbnails (Recent Stories, clip cards); `$size="small"` is scaled down
 * for table-row thumbnails (Recent Content).
 */
const DurationOverlayBadge = styled.div<{ $size?: 'default' | 'small' }>`
  position: absolute;
  bottom: ${({ $size }) => ($size === 'small' ? '4px' : '8px')};
  right: ${({ $size }) => ($size === 'small' ? '4px' : '8px')};
  padding: ${({ $size }) => ($size === 'small' ? '2px 5px' : '4px 8px')};
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  font-size: ${({ $size }) => ($size === 'small' ? '9px' : '11px')};
  font-weight: var(--font-weight-medium);
  color: white;
`;

export default DurationOverlayBadge;
